import FilePreviewComponent from '@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue';
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';
import $ from 'jquery';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';

import {
  ACCEPT_RESPONSE_URL,
  get_headers,
  get_token,
  REJECT_RESPONSE_URL,
  RESOLVE_REQUEST_URL,
  VIEW_SINGLE_REQUEST_INFO_URL
} from '@/utils/constants/constants';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from 'axios';

export default {
  name: 'ResolveRequests',
  mixins: [alert_mixin],
  components: { NavigationBackButton, FilePreviewComponent },

  data: () => ({

    request_note: '',
    is_resolved: '',
    date_requested: '',
    requester_name: '',
    headers: {},
    fields: [],
    request_id: '',
    request_response: [],
    token: "",
    is_loading: false,
    selected_file: '',
    preview_modal: false,

  }),

  mounted() {
    this.headers = get_headers();
    this.token = get_token();
    this.request_id = this.$route.query.request_id;
    this.get_request();
  },

    computed: {
      can_resolve() {
        if (!this.request_response.length) return false;
        // Get only the latest response per document name
        const latest_per_doc = {};
        this.request_response.forEach(doc => {
          latest_per_doc[doc.name] = doc;
        });
        // All latest responses must be approved
        return Object.values(latest_per_doc).every(doc => doc.review_status === 'Approved');
      }
  },

  methods: {

    get_request() {

      axios.get(VIEW_SINGLE_REQUEST_INFO_URL, {
        headers: this.headers,
        params: {
          request_id: parseInt(this.request_id, 10),
        }
      })
        .then(response => {
          const response_data = response.data;

          if (response_data.data.length > 0) {

            var request_info = response_data.data[0];

            this.requester_name = request_info.requested_by_first_name + " " + request_info.requested_by_last_name;
            this.request_note = request_info.message;
            this.is_resolved = request_info.is_resolved;
            this.date_requested = request_info.date_created;

            if (request_info.requested_fields?.length) {
              this.fields = request_info.requested_fields.map(field => ({
                question_id: field.requested_field_id,
                label: field.requested_field_text,
                section_id: field.form_section_id,
              }));
            }

            if (request_info.responses?.length) {
              const requested_for_fields = request_info.requested_fields || [];
              this.request_response = request_info.responses.map(request_response => {
                const matched_field = requested_for_fields.find(
                  f => f.question_id === request_response.question_id
                );
                return {
                  document_id: request_response.id,
                  presigned_url: request_response.presigned_url,
                  name: matched_field
                    ? matched_field.requested_field_text
                    : "Unknown Document",
                  response_accepted: request_response.response_accepted,
                  response_rejected: request_response.response_rejected,
                  review_status:
                    request_response.response_accepted
                      ? "Approved"
                      : request_response.response_rejected
                        ? "Rejected"
                        : "Pending Review",
                  date_created: request_response.date_created,
                  section_id: request_response.section_id,
                };
              });
            }else{
              this.request_response = [];
            }
              this.$nextTick(() => {
                this.initialize_data_table();
              });
          }
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.show_error(error.response.data.message);
          }
        });
    },

    open_document(document) {
      this.selected_file = document;
      this.preview_modal = true
    },

    close_the_file_preview() {
      this.preview_modal = false;
      // Optional: reset the selected_url if needed
      this.selected_file = null;
    },

    approve_response(request_response) {


      const data = {
        response_id: request_response.document_id,
      };

      axios.post(ACCEPT_RESPONSE_URL, data, {
        headers: this.headers
      })
        .then(response => {
          const response_data = response.data;

          if (response_data.status === 'success') {
            this.get_request()
            this.show_success('Response approved successfully');

          } else {
            this.show_error('Error during the Response document approved');
          }

        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.show_error(error.response.data.message);
          }
        });
    },

    reject_response(request_response) {

      const data = {
        response_id: request_response.document_id,
      };

      axios.post(REJECT_RESPONSE_URL, data, {
        headers: this.headers
      })
        .then(response => {
          const response_data = response.data;

          if (response_data.status === 'success') {
            this.get_request()
            this.show_success('Response rejected successfully');

          } else {
            this.show_error('Error during the Response document rejection');
          }

        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.show_error(error.response.data.message);
          }
        });
    },

    resolve_request() {

      const data = {
        request_id: this.request_id
      };

      axios.post(RESOLVE_REQUEST_URL, data, {
        headers: this.headers
      })
        .then(response => {
          const response_data = response.data;

          if (response_data.status === 'success') {
            this.get_request()
            this.show_success('Request resolved successfully');

          } else {
            this.show_error('Error during the Response document approved');
          }

        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.show_error(error.response.data.message);
          }
        });
    },

    redirect_to_view_request() {
      this.$router.push('/view_requests');
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const table_id = '#resolve_request_table';
        const table = $(table_id);

        if (table.length === 0) {
            return;
        }
        
        // Destroy the existing DataTable instance if it exists
        if ($.fn.DataTable.isDataTable(table)) {
            table.DataTable().clear().destroy();
        }
        
        // Store the DataTable instance
        this.dataTable = table.DataTable({
            responsive: true,
            autoWidth: false,
            pageLength: 10
        });
      });
    },
  }
}